// removed by extract-text-webpack-plugin
module.exports = {"description":"_3aW6","icon":"kKev","container":"_3BnF","light":"_2L0g","gray":"AM1E","link":"_221u","title":"H4Tm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AvailablePositions/Position/styles.scss
// module id = 422
// module chunks = 0